/* Description / Reviews tabs + custom Reviews UI
   Backend: Judge.me REST API (free plan).
   Public token only — safe in client-side code. */
(function () {
  'use strict';

  /* ============================================================
     JUDGE.ME CONFIG
     Public token is exposed by design for storefront review reads
     and customer-submitted reviews. Private token never lives here.
     ============================================================ */
  var JM = {
    PUBLIC: 'vXnEOFn6qlP3vkygSZ4ZtHvg3i4',
    SHOP: 'bre41q-vj.myshopify.com',
    PLATFORM: 'shopify',
    BASE: 'https://judge.me/api/v1',
    PER_PAGE: 12
  };

  var STAR_SVG = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>';
  var STAR_EMPTY_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>';

  var AVATAR_VARIANTS = ['green', 'amber', 'ink'];

  function escapeHtml(s) {
    if (s == null) return '';
    return String(s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function initials(name) {
    if (!name) return '·';
    var parts = String(name).trim().split(/\s+/).slice(0, 2);
    return parts.map(function (p) { return p.charAt(0).toUpperCase(); }).join('');
  }

  function relTime(iso) {
    if (!iso) return '';
    var d = new Date(iso);
    if (isNaN(d.getTime())) return '';
    var diff = Math.floor((Date.now() - d.getTime()) / 1000);
    if (diff < 60) return 'just now';
    if (diff < 3600) return Math.floor(diff / 60) + ' min ago';
    if (diff < 86400) return Math.floor(diff / 3600) + ' hr ago';
    var days = Math.floor(diff / 86400);
    if (days < 7) return days + (days === 1 ? ' day' : ' days') + ' ago';
    if (days < 30) {
      var w = Math.floor(days / 7);
      return w + (w === 1 ? ' week' : ' weeks') + ' ago';
    }
    if (days < 365) {
      var m = Math.floor(days / 30);
      return m + (m === 1 ? ' month' : ' months') + ' ago';
    }
    var y = Math.floor(days / 365);
    return y + (y === 1 ? ' year' : ' years') + ' ago';
  }

  function starsHtml(rating) {
    rating = Math.max(0, Math.min(5, parseInt(rating, 10) || 0));
    var html = '';
    for (var i = 1; i <= 5; i++) html += i <= rating ? STAR_SVG : STAR_EMPTY_SVG;
    return html;
  }

  /* ============================================================
     TABS
     ============================================================ */
  function initTabs(root, onReviewsOpen) {
    var buttons = root.querySelectorAll('[data-dr-tab]');
    var panels = root.querySelectorAll('[data-dr-panel]');
    var openedReviewsOnce = false;

    function activate(name, options) {
      options = options || {};
      buttons.forEach(function (btn) {
        var on = btn.dataset.drTab === name;
        btn.classList.toggle('is-active', on);
        btn.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      panels.forEach(function (panel) {
        var on = panel.dataset.drPanel === name;
        panel.classList.toggle('is-active', on);
        if (on) panel.removeAttribute('hidden');
        else panel.setAttribute('hidden', '');
      });
      if (name === 'reviews' && !openedReviewsOnce) {
        openedReviewsOnce = true;
        if (typeof onReviewsOpen === 'function') onReviewsOpen();
      }
      if (options.scroll) {
        var target = root.querySelector('[data-dr-panel="' + name + '"]');
        if (target) {
          var top = target.getBoundingClientRect().top + window.pageYOffset - 100;
          window.scrollTo({ top: top, behavior: 'smooth' });
        }
      }
    }

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () { activate(btn.dataset.drTab); });
    });

    function handleHash() {
      var hash = (window.location.hash || '').replace('#', '').toLowerCase();
      if (hash === 'reviews') activate('reviews', { scroll: true });
      else if (hash) activate('description');
    }
    window.addEventListener('hashchange', handleHash);
    if (window.location.hash) setTimeout(handleHash, 50);

    root.__drActivate = activate;
  }

  /* ============================================================
     JUDGE.ME: FETCH REVIEWS via widget endpoint (free plan compatible)
     Returns rendered widget HTML inside JSON; we parse to extract data.
     ============================================================ */
  function fetchWidgetPage(handle, page) {
    var url = JM.BASE + '/widgets/product_review'
      + '?api_token=' + encodeURIComponent(JM.PUBLIC)
      + '&shop_domain=' + encodeURIComponent(JM.SHOP)
      + '&platform=' + JM.PLATFORM
      + '&handle=' + encodeURIComponent(handle)
      + '&url=' + encodeURIComponent(window.location.href)
      + '&page=' + (page || 1);
    return fetch(url, { method: 'GET' })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(function (data) {
        return parseWidgetHtml(data && data.widget ? data.widget : '');
      });
  }

  // Judge.me deprecated the widgets/product_review endpoint for free-plan shops; reviews now
  // arrive via product.metafields.judgeme.widget, exposed by product-reviews-tab.liquid.
  function readMetafieldReviews(productId) {
    if (!productId || !window.JM_REVIEWS) return null;
    var html = window.JM_REVIEWS[productId];
    if (!html || typeof html !== 'string' || html.length < 20) return null;
    return parseWidgetHtml(html);
  }

  /* Primary source: tripstash.reviews JSON metafield, written hourly by the
     n8n sync from the Judge.me API. Judge.me's own metafield push (JM_REVIEWS
     below) proved dormant for weeks, so it is only a fallback. */
  function readSyncedReviews(productId) {
    if (!productId || !window.TS_REVIEWS) return null;
    var data = window.TS_REVIEWS[productId];
    if (!data || typeof data !== 'object' || !Array.isArray(data.reviews)) return null;
    return {
      reviews: data.reviews,
      count: data.count || data.reviews.length || 0,
      avg: data.avg || 0,
      distribution: data.distribution || { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 }
    };
  }

  function fetchAllReviews(handle, productId) {
    var synced = readSyncedReviews(productId);
    if (synced) {
      return Promise.resolve(synced);
    }
    var fromMetafield = readMetafieldReviews(productId);
    if (fromMetafield && (fromMetafield.reviews.length || fromMetafield.count)) {
      return Promise.resolve(fromMetafield);
    }
    return fetchWidgetPage(handle, 1).then(function (first) {
      var perPage = first.reviews.length || 5;
      var totalPages = first.count > 0 ? Math.ceil(first.count / perPage) : 1;
      if (totalPages <= 1) return first;
      var promises = [];
      for (var p = 2; p <= totalPages; p++) promises.push(fetchWidgetPage(handle, p));
      return Promise.all(promises).then(function (rest) {
        var all = first.reviews.slice();
        rest.forEach(function (page) { all = all.concat(page.reviews || []); });
        return {
          reviews: all,
          count: first.count,
          avg: first.avg,
          distribution: first.distribution
        };
      });
    });
  }

  function parseWidgetHtml(html) {
    html = html || '';
    // Regex-based stats extraction (DOMParser sometimes fails on Judge.me's nested HTML)
    var avgMatch = html.match(/data-average-rating=['"]([\d.]+)['"]/);
    var countMatch = html.match(/data-number-of-reviews=['"](\d+)['"]/);
    var avg = avgMatch ? parseFloat(avgMatch[1]) || 0 : 0;
    var count = countMatch ? parseInt(countMatch[1], 10) || 0 : 0;

    var distribution = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 };
    var distRe = /data-rating=['"](\d+)['"][^>]*data-frequency=['"](\d+)['"]/g;
    var m;
    while ((m = distRe.exec(html)) !== null) {
      var r = parseInt(m[1], 10);
      var f = parseInt(m[2], 10);
      if (r >= 1 && r <= 5) distribution[r] = f;
    }

    var doc = new DOMParser().parseFromString(html, 'text/html');
    var reviews = [];

    // .jdgm-rev cards have photos stripped on the free plan; the gallery JSON keeps picture_urls.
    var gallery = doc.querySelector('.jdgm-gallery-data');
    if (gallery) {
      var rawJson = gallery.getAttribute('data-json') || '';
      try {
        var galleryArr = JSON.parse(rawJson);
        if (Array.isArray(galleryArr)) {
          galleryArr.forEach(function (r) {
            var pics = (r.pictures_urls || []).map(function (p) {
              return { urls: { compact: p.compact || p.original, original: p.original || p.compact } };
            });
            reviews.push({
              id: r.uuid || '',
              rating: parseInt(r.rating, 10) || 0,
              title: r.title || '',
              body: (r.body_html || '').replace(/<[^>]+>/g, '').trim(),
              reviewer: { name: r.reviewer_name || 'Anonymous' },
              created_at: r.created_at || '',
              verified: r.verified_buyer ? 'buyer' : false,
              pictures: pics
            });
          });
        }
      } catch (e) {}
    }

    var seen = {};
    reviews.forEach(function (r) { if (r.id) seen[r.id] = true; });

    doc.querySelectorAll('.jdgm-rev').forEach(function (el) {
      var ratingEl = el.querySelector('.jdgm-rev__rating');
      var rating = ratingEl ? (parseInt(ratingEl.getAttribute('data-score'), 10) || 0) : 0;
      var titleEl = el.querySelector('.jdgm-rev__title');
      var bodyEl = el.querySelector('.jdgm-rev__body');
      var authorEl = el.querySelector('.jdgm-rev__author');
      var tsEl = el.querySelector('.jdgm-rev__timestamp');
      var verified = el.getAttribute('data-verified-buyer') === 'true';
      var pics = Array.prototype.slice.call(el.querySelectorAll('.jdgm-rev__pics img, .jdgm-rev__pics .jdgm-rev__pic-img'))
        .map(function (img) {
          var src = img.getAttribute('data-src') || img.getAttribute('src') || img.getAttribute('data-original');
          return src ? { urls: { compact: src, original: src } } : null;
        })
        .filter(Boolean);

      var cardId = el.getAttribute('data-review-id') || '';
      if (cardId && seen[cardId]) return;
      if (cardId) seen[cardId] = true;
      reviews.push({
        id: cardId,
        rating: rating,
        title: titleEl ? titleEl.textContent.trim() : '',
        body: bodyEl ? bodyEl.textContent.trim() : '',
        reviewer: { name: authorEl ? authorEl.textContent.trim() : 'Anonymous' },
        created_at: tsEl ? (tsEl.getAttribute('data-content') || '') : '',
        verified: verified ? 'buyer' : false,
        pictures: pics
      });
    });

    return { reviews: reviews, count: count, avg: avg, distribution: distribution };
  }

  /* ============================================================
     JUDGE.ME: SUBMIT REVIEW (with optional photos)
     ============================================================ */
  function submitJudgeMeReview(productId, fields, files) {
    // Multipart so photos can ride along as pictures[] in the same request.
    var fd = new FormData();
    fd.append('api_token', JM.PUBLIC);
    fd.append('shop_domain', JM.SHOP);
    fd.append('platform', JM.PLATFORM);
    fd.append('id', productId);
    fd.append('name', fields.name || '');
    fd.append('email', fields.email || '');
    fd.append('rating', fields.rating || '');
    fd.append('title', fields.title || '');
    fd.append('body', fields.body || '');
    if (fields.order_number) fd.append('reviewer_external_id', fields.order_number);
    (files || []).forEach(function (f) { fd.append('pictures[]', f); });

    return fetch(JM.BASE + '/reviews', { method: 'POST', body: fd })
      .then(function (r) {
        // Judge.me returns 200 or 201 on success, 422 on validation failure.
        return r.json().then(function (data) {
          return { ok: r.ok, status: r.status, data: data };
        }).catch(function () {
          return { ok: r.ok, status: r.status, data: null };
        });
      });
  }

  /* ============================================================
     RENDER: review cards
     ============================================================ */
  function renderReviewCard(review, idx) {
    var rating = parseInt(review.rating, 10) || 0;
    var name = review.reviewer && review.reviewer.name ? review.reviewer.name : 'Anonymous';
    var verified = review.verified === 'buyer' || review.verified === true;
    var pictures = (review.pictures || []).map(function (p) {
      return p && p.urls ? (p.urls.compact || p.urls.original || p.urls.huge) : null;
    }).filter(Boolean);
    var avatarVariant = AVATAR_VARIANTS[idx % AVATAR_VARIANTS.length];

    var html = '';
    html += '<article class="rt-card" data-rt-rating="' + rating + '" data-rt-photos="' + pictures.length + '">';
    html +=   '<header class="rt-card__head">';
    html +=     '<div class="rt-card__stars rt__stars" aria-label="' + rating + ' out of 5 stars">' + starsHtml(rating) + '</div>';
    if (verified) {
      html +=   '<span class="rt-card__verified">';
      html +=     '<svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg>';
      html +=     'Verified buyer';
      html +=   '</span>';
    }
    html +=   '</header>';
    if (review.title) html += '<h3 class="rt-card__title">' + escapeHtml(review.title) + '</h3>';
    if (review.body) html += '<p class="rt-card__body">' + escapeHtml(review.body) + '</p>';
    if (pictures.length) {
      html += '<div class="rt-card__photos" data-rt-photos-row>';
      pictures.forEach(function (src) {
        html += '<button type="button" class="rt-card__photo" data-rt-lightbox="' + escapeHtml(src) + '">';
        html +=   '<img src="' + escapeHtml(src) + '" alt="Customer photo">';
        html += '</button>';
      });
      html += '</div>';
    }
    html +=   '<footer class="rt-card__foot">';
    html +=     '<div class="rt-card__avatar rt-card__avatar--' + avatarVariant + '" aria-hidden="true">' + escapeHtml(initials(name)) + '</div>';
    html +=     '<div class="rt-card__meta">';
    html +=       '<div class="rt-card__byline"><span class="rt-card__author">' + escapeHtml(name) + '</span><span>·</span><span>' + escapeHtml(relTime(review.created_at)) + '</span></div>';
    html +=     '</div>';
    html +=   '</footer>';
    html += '</article>';
    return html;
  }

  function renderEmptyState(list) {
    list.innerHTML =
      '<div class="rt-empty">' +
        '<div class="rt-empty__icon">' + STAR_EMPTY_SVG.replace('width="1.5"', 'width="2"') + '</div>' +
        '<h3 class="rt-empty__title">No reviews yet</h3>' +
        '<p class="rt-empty__text">Be the first. Every review on Tripstash comes from a real order.</p>' +
        '<button type="button" class="rt__cta" data-rt-open-form>' +
          '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 20h9"/><path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4 12.5-12.5z"/></svg>' +
          '<span>Leave a review</span>' +
        '</button>' +
      '</div>';
  }

  function setHidden(el, hidden) {
    if (!el) return;
    if (hidden) el.setAttribute('hidden', '');
    else el.removeAttribute('hidden');
  }

  function updateRatingSchema(rt, count, avg) {
    var id = 'rt-rating-schema';
    var existing = document.getElementById(id);
    if (!count) {
      if (existing) existing.remove();
      return;
    }
    var name = rt.getAttribute('data-rt-product-name') || document.title;
    var data = {
      '@context': 'https://schema.org',
      '@type': 'AggregateRating',
      itemReviewed: { '@type': 'Product', name: name },
      ratingValue: (Math.round(avg * 10) / 10).toFixed(1),
      reviewCount: count
    };
    var script = existing || document.createElement('script');
    script.type = 'application/ld+json';
    script.id = id;
    script.textContent = JSON.stringify(data);
    if (!existing) document.head.appendChild(script);
  }

  function updateSummary(rt, count, avg, distribution) {
    var header = rt.querySelector('[data-rt-header]');
    var summary = rt.querySelector('[data-rt-summary]');
    var barsWrap = rt.querySelector('[data-rt-bars]');
    var controls = rt.querySelector('[data-rt-controls]');
    var hasReviews = count > 0;

    setHidden(header, !hasReviews);
    setHidden(summary, !hasReviews);
    setHidden(barsWrap, !hasReviews);
    setHidden(controls, !hasReviews);

    var tabCount = document.querySelector('[data-dr-review-count]');
    if (tabCount) tabCount.textContent = count;

    updateRatingSchema(rt, count, avg);

    if (!hasReviews) return;

    var avgEl = rt.querySelector('[data-rt-avg]');
    var countEl = rt.querySelector('[data-rt-count]');
    var headerStars = rt.querySelector('[data-rt-summary-stars]');
    if (avgEl) avgEl.textContent = (Math.round(avg * 10) / 10).toFixed(1);
    if (countEl) countEl.textContent = count;
    if (headerStars) headerStars.innerHTML = starsHtml(Math.round(avg));

    var bars = rt.querySelectorAll('.rt__bar');
    if (bars && bars.length === 5 && distribution) {
      var stars = [5, 4, 3, 2, 1];
      bars.forEach(function (bar, i) {
        var n = distribution[stars[i]] || 0;
        var pct = count ? (n * 100 / count) : 0;
        var fill = bar.querySelector('.rt__bar-fill');
        var cnt = bar.querySelector('.rt__bar-count');
        if (fill) fill.style.width = pct + '%';
        if (cnt) cnt.textContent = n;
      });
    }
  }

  /* ============================================================
     REVIEW LIST: filters, sort, load more, live load
     ============================================================ */
  function initReviewList(rt) {
    var list = rt.querySelector('[data-rt-list]');
    if (!list) return;
    var chips = rt.querySelectorAll('[data-rt-filter]');
    var sortSelect = rt.querySelector('[data-rt-sort]');
    var loadMore = rt.querySelector('[data-rt-loadmore]');
    var loadMoreWrap = rt.querySelector('.rt__loadmore-wrap');
    var productId = rt.dataset.rtProductId;
    var productHandle = rt.dataset.rtProductHandle;

    var state = {
      currentFilter: 'all',
      currentSort: 'recent',
      allReviews: [],
      totalCount: 0
    };

    function applyFilterAndSort() {
      var arr = state.allReviews.slice();

      // Filter
      if (state.currentFilter !== 'all') {
        if (state.currentFilter === 'photo') {
          arr = arr.filter(function (r) { return (r.pictures || []).length > 0; });
        } else {
          var n = parseInt(state.currentFilter, 10);
          arr = arr.filter(function (r) { return parseInt(r.rating, 10) === n; });
        }
      }

      // Sort
      switch (state.currentSort) {
        case 'highest': arr.sort(function (a, b) { return b.rating - a.rating; }); break;
        case 'lowest':  arr.sort(function (a, b) { return a.rating - b.rating; }); break;
        case 'helpful': arr.sort(function (a, b) { return (b.curated || 0) - (a.curated || 0); }); break;
        default:        arr.sort(function (a, b) { return new Date(b.created_at) - new Date(a.created_at); });
      }

      if (!arr.length) {
        renderEmptyState(list);
        if (loadMoreWrap) loadMoreWrap.style.display = 'none';
        return;
      }
      list.innerHTML = arr.map(renderReviewCard).join('');
      // Free-plan widget endpoint returns the first page (~5 reviews) all at once.
      // Hide load-more for now — Judge.me's secondary pagination URL needs auth headers we can't replicate.
      if (loadMoreWrap) loadMoreWrap.style.display = 'none';
    }

    function load() {
      if (!productHandle) return Promise.resolve();
      list.classList.add('is-loading');
      return fetchAllReviews(productHandle, productId).then(function (parsed) {
        list.classList.remove('is-loading');
        state.allReviews = parsed.reviews || [];

        // Compute stats from reviews as a fallback if Judge.me's HTML metadata
        // didn't yield clean values (regex can drift if their format changes).
        var fbCount = state.allReviews.length;
        var fbDist = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 };
        var fbSum = 0;
        state.allReviews.forEach(function (r) {
          var n = parseInt(r.rating, 10) || 0;
          if (n >= 1 && n <= 5) { fbDist[n]++; fbSum += n; }
        });
        var fbAvg = fbCount ? fbSum / fbCount : 0;

        var count = parsed.count || fbCount;
        var avg = parsed.avg || fbAvg;
        var dist = parsed.distribution;
        var distSum = dist ? (dist[1]+dist[2]+dist[3]+dist[4]+dist[5]) : 0;
        if (!distSum) dist = fbDist;

        state.totalCount = count;
        updateSummary(rt, count, avg, dist);
        applyFilterAndSort();
      }).catch(function (err) {
        list.classList.remove('is-loading');
        console.warn('[reviews-tab] fetch failed', err);
      });
    }

    // Filter chips
    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        chips.forEach(function (c) { c.classList.remove('is-active'); });
        chip.classList.add('is-active');
        state.currentFilter = chip.dataset.rtFilter;
        applyFilterAndSort();
      });
    });

    if (sortSelect) {
      sortSelect.addEventListener('change', function () {
        state.currentSort = sortSelect.value;
        applyFilterAndSort();
      });
    }

    rt.__rtLoadFirstPage = function () { load(); };
    rt.__rtRefresh = function () { load(); };
  }

  /* ============================================================
     LIGHTBOX
     ============================================================ */
  function initLightbox(rt) {
    var overlay = rt.querySelector('[data-rt-lightbox-overlay]');
    var img = rt.querySelector('[data-rt-lightbox-img]');
    if (!overlay || !img) return;

    rt.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-rt-lightbox]');
      if (trigger) {
        img.src = trigger.dataset.rtLightbox;
        overlay.removeAttribute('hidden');
        return;
      }
      if (e.target.closest('[data-rt-lightbox-close]') || e.target === overlay) {
        overlay.setAttribute('hidden', '');
        img.src = '';
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !overlay.hasAttribute('hidden')) {
        overlay.setAttribute('hidden', '');
        img.src = '';
      }
    });
  }

  /* ============================================================
     MODAL: open/close, star input, upload, submit to Judge.me
     ============================================================ */
  function initModal(rt) {
    var modal = rt.querySelector('[data-rt-modal]');
    var form = rt.querySelector('[data-rt-form]');
    var thanks = rt.querySelector('[data-rt-thanks]');
    var submitBtn = rt.querySelector('[data-rt-submit]');
    var submitLabel = rt.querySelector('[data-rt-submit-label]');
    if (!modal || !form) return;

    var stagedFiles = [];
    var MAX_FILES = 5;
    var MAX_BYTES = 5 * 1024 * 1024;

    function open() {
      modal.removeAttribute('hidden');
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('rt-modal-open');
      form.style.display = '';
      thanks.setAttribute('hidden', '');
    }

    function close() {
      modal.setAttribute('hidden', '');
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('rt-modal-open');
      form.reset();
      stagedFiles = [];
      var stars = form.querySelectorAll('[data-rt-star]');
      stars.forEach(function (s) { s.classList.remove('is-active'); });
      var hidden = form.querySelector('[data-rt-rating-value]');
      if (hidden) hidden.value = '';
      var previews = form.querySelector('[data-rt-upload-previews]');
      if (previews) previews.innerHTML = '';
    }

    // Delegated open: any [data-rt-open-form] (header CTA AND empty-state CTA)
    rt.addEventListener('click', function (e) {
      if (e.target.closest('[data-rt-open-form]')) {
        e.preventDefault();
        open();
      }
      if (e.target.closest('[data-rt-modal-close]')) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hasAttribute('hidden')) close();
    });

    // Star rating input
    var stars = form.querySelectorAll('[data-rt-star]');
    var hiddenValue = form.querySelector('[data-rt-rating-value]');
    stars.forEach(function (star) {
      star.addEventListener('mouseenter', function () {
        var n = parseInt(star.dataset.rtStar, 10);
        stars.forEach(function (s) {
          s.classList.toggle('is-hover-active', parseInt(s.dataset.rtStar, 10) <= n);
        });
      });
      star.addEventListener('mouseleave', function () {
        stars.forEach(function (s) { s.classList.remove('is-hover-active'); });
      });
      star.addEventListener('click', function () {
        var n = parseInt(star.dataset.rtStar, 10);
        hiddenValue.value = n;
        stars.forEach(function (s) {
          s.classList.toggle('is-active', parseInt(s.dataset.rtStar, 10) <= n);
        });
      });
    });

    // Upload + previews + drag&drop
    var upload = form.querySelector('[data-rt-upload]');
    var input = form.querySelector('[data-rt-upload-input]');
    var previews = form.querySelector('[data-rt-upload-previews]');

    function renderPreviews() {
      previews.innerHTML = '';
      stagedFiles.forEach(function (file, idx) {
        var url = URL.createObjectURL(file);
        var wrap = document.createElement('div');
        wrap.className = 'rt-upload__preview';
        wrap.innerHTML =
          '<img src="' + url + '" alt="">' +
          '<button type="button" class="rt-upload__preview-remove" aria-label="Remove">×</button>';
        wrap.querySelector('button').addEventListener('click', function () {
          stagedFiles.splice(idx, 1);
          renderPreviews();
        });
        previews.appendChild(wrap);
      });
    }

    function addFiles(fileList) {
      Array.prototype.slice.call(fileList).forEach(function (file) {
        if (stagedFiles.length >= MAX_FILES) return;
        if (file.type.indexOf('image/') !== 0) return;
        if (file.size > MAX_BYTES) return;
        stagedFiles.push(file);
      });
      renderPreviews();
    }

    if (input) input.addEventListener('change', function (e) { addFiles(e.target.files); });
    if (upload) {
      ['dragenter', 'dragover'].forEach(function (ev) {
        upload.addEventListener(ev, function (e) { e.preventDefault(); upload.classList.add('is-drag'); });
      });
      ['dragleave', 'drop'].forEach(function (ev) {
        upload.addEventListener(ev, function (e) { e.preventDefault(); upload.classList.remove('is-drag'); });
      });
      upload.addEventListener('drop', function (e) {
        if (e.dataTransfer && e.dataTransfer.files) addFiles(e.dataTransfer.files);
      });
    }

    // Submit
    form.addEventListener('submit', function (e) {
      e.preventDefault();

      if (!hiddenValue.value) {
        alert('Please select a star rating.');
        return;
      }

      submitBtn.disabled = true;
      var originalLabel = submitLabel.textContent;
      submitLabel.textContent = stagedFiles.length ? 'Uploading...' : 'Submitting...';

      var fd = new FormData(form);
      var fields = {
        rating: hiddenValue.value,
        title: fd.get('title') || '',
        body: fd.get('body') || '',
        name: fd.get('name') || '',
        email: fd.get('email') || '',
        order_number: fd.get('order_number') || ''
      };

      var productId = rt.dataset.rtProductId;
      submitJudgeMeReview(productId, fields, stagedFiles)
        .then(function (res) {
          if (res.ok || res.status === 201 || res.status === 200) {
            form.style.display = 'none';
            thanks.removeAttribute('hidden');
          } else {
            // 422 with photos → retry text-only
            if (res.status === 422 && stagedFiles.length) {
              submitLabel.textContent = 'Retrying without photos...';
              return submitJudgeMeReview(productId, fields, []).then(function (r2) {
                if (r2.ok || r2.status === 201 || r2.status === 200) {
                  form.style.display = 'none';
                  thanks.removeAttribute('hidden');
                  // Note inside thanks
                  var t = rt.querySelector('.rt-thanks__text');
                  if (t) t.textContent = 'Your review was submitted, but we couldn\'t upload your photos. Please try again with smaller images, or email them to us.';
                } else {
                  surfaceError(r2);
                }
              });
            }
            surfaceError(res);
          }
        })
        .catch(function (err) {
          console.warn('[reviews-tab] submit failed', err);
          alert('Something went wrong submitting your review. Please try again or email us.');
        })
        .then(function () {
          submitBtn.disabled = false;
          submitLabel.textContent = originalLabel;
        });

      function surfaceError(res) {
        var msg = 'Couldn\'t submit your review.';
        if (res.data && res.data.error) msg += ' ' + res.data.error;
        else if (res.data && res.data.message) msg += ' ' + res.data.message;
        else msg += ' (Status ' + res.status + ')';
        alert(msg);
      }
    });
  }

  /* ============================================================
     INIT
     ============================================================ */
  document.addEventListener('DOMContentLoaded', function () {
    var rt = document.querySelector('[data-rt]');
    var tabsRoot = document.querySelector('[data-dr-tabs]');

    function loadOnFirstOpen() {
      if (rt && rt.__rtLoadFirstPage) rt.__rtLoadFirstPage();
    }

    if (tabsRoot) initTabs(tabsRoot, loadOnFirstOpen);
    if (rt) {
      initReviewList(rt);
      initLightbox(rt);
      initModal(rt);
      // Always fetch on page load so summary + cards are fresh,
      // not gated to first tab open (avoids stale state across imports).
      if (rt.__rtLoadFirstPage) rt.__rtLoadFirstPage();
    }
  });
})();
